import { render, staticRenderFns } from "./customerOrderChannelSelect.vue?vue&type=template&id=f40be3dc&"
import script from "./customerOrderChannelSelect.vue?vue&type=script&lang=js&"
export * from "./customerOrderChannelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports